import { TransactionDetailOptionFormType } from '@/features/transaction_items/Detail/type';
import { useTranslation } from '@/i18n';
import { Label } from '@moneyforward/ap-frontend-components';
import classNames from 'classnames';
import { FC, memo, useCallback, useMemo } from 'react';
import { Control } from 'react-hook-form';
import { DebounceFormInput } from './DebounceFormInput';
import styles from './TransactionDetailOptionForm.module.scss';

const cx = classNames.bind(styles);

export type Props = {
  control: Control<TransactionDetailOptionFormType>;
};

export const OptionPriority: FC<Props> = memo(({ control }) => {
  const { t } = useTranslation();

  const convertFullWidthToHalfWidth = useCallback((str: string): string => {
    return str.replace(/[０-９]/g, (match) => {
      return String.fromCharCode(match.charCodeAt(0) - 0xfee0);
    });
  }, []);

  const rules = useMemo(
    () => ({
      required: t('required'),
      pattern: {
        value: /^\d{1,8}$/,
        message: t('transaction_items.detail.options.validation.priority'),
      },
      maxLength: {
        value: 8,
        message: t('transaction_items.detail.options.validation.priority'),
      },
    }),
    [t]
  );

  return (
    <div className={cx(styles['row'])}>
      <Label htmlFor='priority' required>
        <div className={cx(styles['bold'])}>
          {t('transaction_items.detail.options.priority')}
        </div>
      </Label>
      <DebounceFormInput
        control={control}
        name='priority'
        inputId='priority'
        testId='transaction-detail-option-priority'
        rules={rules}
        transform={convertFullWidthToHalfWidth}
        debounceMs={2000}
      />
    </div>
  );
});
OptionPriority.displayName = 'OptionPriority';
